import PicturesApp from 'station/components/picture/PicturesApp'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitle } from 'utils/StationUtils'

const DistributionUnitPicturesApp = ({

}) => {
    const {
        distributionUnit,
        distributionUnits,
    } = useSelector(store => ({
        distributionUnit: store.DistributionUnitReducer.distributionUnit,
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.distributionUnit,
        href: 'distributionUnit',
    }, {
        title: getStationTitle(distributionUnit),
        href: `station/distributionUnit/${distributionUnit?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/distributionUnit/${distributionUnit?.id}/picture`,
    }], [distributionUnit])

    return (
        <PicturesApp
            stations={distributionUnits}
            station={distributionUnit}
            stationType='distributionUnit'
        />
    )
}

export default DistributionUnitPicturesApp